import { useEffect, useState } from "react";
import { apiFetch } from "../../../app/apiClient";
import { useAppSelector } from "../../../app/hooks";
import { activeFolder, activeEmail } from "../../inbox/emailSlice";
import ComponentLoading from "../../../components/ComponentLoading";
import { currentToken } from "../../login/loginSlice";
import EmailBody from "./EmailBody";

function PreviewPane() {
    let [currentLoadingEvents, setCurrentLoadingEvents] = useState(0);
    let appMessage = useAppSelector(activeEmail);
    let appFolder = useAppSelector(activeFolder);
    let userToken = useAppSelector(currentToken);
    let [emailTitle, setEmailTitle] = useState("Select an Email to View");
    let [fromComponent, setFromComponent] = useState(<></>);
    let [emailComponent, setEmailComponent] = useState(<></>);

    useEffect(() => {
        if (!appMessage) {
            setEmailTitle("Select an Email to View");
            setFromComponent(<></>);
            setEmailComponent(<></>);
            return;
        }

        const abortController = new AbortController();
        setCurrentLoadingEvents(1);
        apiFetch("/api/email/" + appFolder! + "/" + appMessage, {
            method: "GET",
            token: userToken,
            signal: abortController.signal
        }).then((data) => {
            return data.json();
        }).then((data) => {
            setEmailTitle(data.email.subject || "(No Subject)");
            setFromComponent(<div className={"addressComponent"}>
                <strong>From: {data.email.from.text}</strong>
            </div>);
            setEmailComponent(<EmailBody html={data.email.body.html} text={data.email.body.text} />);
            setCurrentLoadingEvents(0);
        }).catch((error) => {
            if (error.name === "AbortError") return;
            setCurrentLoadingEvents(0);
        });

        return () => abortController.abort();
    }, [appMessage, appFolder, userToken]);

    return(
    <div className={"previewPane"}>
        <ComponentLoading isActive={currentLoadingEvents > 0} />
        <h3>{emailTitle}</h3>
        {fromComponent}
        {emailComponent}
    </div>)
}

export default PreviewPane;